import { roomPopupSlice } from './slice';

export const {
  openRoomPopup: openRoomPopupAction,
  closeRoomPopup: closeRoomPopupAction,
} = roomPopupSlice.actions;
